// @flow
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clone from 'ramda/es/clone';
import path from 'ramda/es/path';

import api from 'app/actions/api';
import action from 'app/common/lib/action';

import { defaultBalanceHistoryState } from './AccountBalanceContext';
import type { AccountBalanceHistoryType } from './AccountBalanceTypes';


export default function useBalanceHistory() {
  const dispatch = useDispatch();
  const { t } = useTranslation('finances');
  const [balanceHistory, setBalanceHistory] = useState<AccountBalanceHistoryType>(defaultBalanceHistoryState);
  const [balanceHistoryLoading, setBalanceHistoryLoading] = useState(false);

  const balanceRequest = useCallback(async (from: string, to: string) => {
    const requestPath = 'account/finances';
    const type = 'get';
    const rest = {
      params: {
        from_date: from,
        to_date: to,
      },
    };
    try {
      setBalanceHistoryLoading(true);
      const res = await api(requestPath, type, rest);
      const historyResult: AccountBalanceHistoryType = path(['data', 'data'], res) || defaultBalanceHistoryState;
      setBalanceHistory(historyResult);
      setBalanceHistoryLoading(false);
    } catch (error) {
      const errorSave = {
        err: t('request_finances_failed'),
        path: requestPath,
        type,
        rest,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
    }
  }, [dispatch, t]);

  return [balanceHistory, balanceRequest, balanceHistoryLoading];
}
